<template>
  <div class="loading-overlay">
    <div class="loading-content">
      <div class="spinner-wrapper">
        <div class="spinner-circle"></div>
        <div class="spinner-logo">
          <img src="@/assets/images/banner/logo.png" alt="Logo" class="rotating-logo" />
        </div>
      </div>
      <p class="loading-text">Đang tải...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingTET",
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px) saturate(180%);
  -webkit-backdrop-filter: blur(10px) saturate(180%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  pointer-events: all;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spinner-wrapper {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-circle {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(46, 125, 50, 0.1);
  border-top: 4px solid #2e7d32;
  border-radius: 50%;
  animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.spinner-logo {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.rotating-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  animation: pulse 2s ease-in-out infinite;
}

.loading-text {
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #2e7d32;
  margin: 0;
  letter-spacing: 0.05em;
  animation: fadeText 1.5s ease-in-out infinite alternate;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(0.95);
  }

  50% {
    transform: scale(1.08);
  }
}

@keyframes fadeText {
  0% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}
</style>
